const postfixArr = [
  '--1st',
  '--2nd',
  '--3rd',
  '--4th',
  '--5th',
  '--6th',
  '--7th',
  '--8th',
  '--9th',
  '--10th',
];

export default function createFieldClassNameByParticipantOrder(
  classNamePrefix: string,
  order: number
) {
  const orderValue = Math.max(Number.isInteger(order) ? order : 1, 1);
  return classNamePrefix + postfixArr[(orderValue - 1) % postfixArr.length];
}
